<div class="empty {{ size }}">
  <span class="name">{{ nameDisplayed }}</span>
</div>
